module.exports = __webpack_public_path__ + "img/entertainment-dark-7.76bf5b1c.jpg";